// Column ids — used by the column defs and by the sort payload.
export const OUTGOING_SHIPMENT_COLUMNS = Object.freeze({
  shipmentId: 'shipmentId',
  materialName: 'materialName',
  linkedOrders: 'linkedOrders',
  facilityName: 'facilityName',
  status: 'status',
  soldTo: 'soldTo',
  terminal: 'terminal',
  vesselName: 'vesselName',
  shippingTo: 'shippingTo',
  unitType: 'unitType',
  shipmentQuantity: 'shipmentQuantity',
  allocatedQuantity: 'allocatedQuantity',
  remainingToAllocateQuantity: 'remainingToAllocateQuantity',
  dateOfDispatch: 'dateOfDispatch',
  discrepancies: 'discrepancies',
});

// Column id → an `OutgoingShipmentOrderByField` — DB-backed columns only, so no vessel name.
export const OUTGOING_SHIPMENT_SORT_FIELDS = Object.freeze({
  [OUTGOING_SHIPMENT_COLUMNS.shipmentId]: 'shipmentNo',
  [OUTGOING_SHIPMENT_COLUMNS.dateOfDispatch]: 'dispatchDate',
});

// Linked orders tab → a `PendingOrderOrderByField`. The enum offers nothing else this tab shows.
export const SHIPMENT_LINKED_ORDER_SORT_FIELDS = Object.freeze({
  orderNo: 'orderNo',
  contractedQuantity: 'contractedQuantity',
  dispatchBy: 'dispatchDate',
});
